import React, { ReactNode } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { v4 } from "uuid";

export const createTooltip = (
    element: ReactNode | string,
    tooltip: React.JSX.Element | string
): ReactNode | string => {
    if (tooltip) {
        const tooltipContent = (
            <Tooltip id={`tooltip-${v4()}`}>{tooltip}</Tooltip>
        );

        return (
            <OverlayTrigger overlay={tooltipContent}>
                <span>{element}</span>
            </OverlayTrigger>
        );
    } else {
        return element;
    }
};

export type IVTooltipProps = {
    children: React.ReactNode;
    tooltip: string | React.JSX.Element;
};

export const VTooltip = (props: IVTooltipProps) =>
    createTooltip(props.children, props.tooltip);
